var AuthPathConstants;
(function (AuthPathConstants) {
    //https://my-base-rs.herokuapp.com
    //https://qwerzxvxzvzxvxzv.herokuapp.com
    AuthPathConstants["BASE"] = "https://qwerzxvxzvzxvxzv.herokuapp.com";
    AuthPathConstants["USERS"] = "/users";
    AuthPathConstants["SIGIN"] = "/signin";
    AuthPathConstants["TOKENS"] = "/tokens";
    AuthPathConstants["STATISTICS"] = "/statistics";
    AuthPathConstants["WORDS"] = "/words";
    AuthPathConstants["AGGREGATED_WORDS"] = "/aggregatedWords";
    AuthPathConstants["FILTER_BY_HARD"] = "filter={\"userWord.difficulty\":\"hard\"}";
    AuthPathConstants["FILTER_BY_HARD_AND_KNOWN"] = "filter={\"$or\":[{\"userWord.difficulty\":\"hard\", \"userWord.optional.isKnown\":\"true\"}]}";
})(AuthPathConstants || (AuthPathConstants = {}));
export default AuthPathConstants;
